
import common from './ms_MY/common'
import areaCode from './ms_MY/areaCode'
import communicateCenter from './ms_MY/communicateCenter'
import components from './ms_MY/components'
import course from './ms_MY/course'
import courseDetail from './ms_MY/courseDetail'
import examDetail from './ms_MY/examDetail'
import home from './ms_MY/home'
import humanTraining from './ms_MY/humanTraining'
import inforList from './ms_MY/inforList'
import Information from './ms_MY/Information'
import intelligentOfficialDoc from './ms_MY/intelligentOfficialDoc'
import knowledgeLib from './ms_MY/knowledgeLib'
import LearnRecords from './ms_MY/LearnRecords'
import Login from './ms_MY/Login'
import myCourse from './ms_MY/myCourse'
import myExam from './ms_MY/myExam'
import mynews from './ms_MY/mynews'
import mySetting from './ms_MY/mySetting'
import mytopic from './ms_MY/mytopic'
import myTrainingClass from './ms_MY/myTrainingClass'
import myTrainingDetail from './ms_MY/myTrainingDetail'
import myWork from './ms_MY/myWork'
import post from './ms_MY/post'
import postDetail from './ms_MY/postDetail'
import practiceTrain from './ms_MY/practiceTrain'
import publicExam from './ms_MY/publicExam'
import questionnaire from './ms_MY/questionnaire'
import rules from './ms_MY/rules'
import search from './ms_MY/search'
import studyMap from './ms_MY/studyMap'
import topic from './ms_MY/topic'
import topicDetail from './ms_MY/topicDetail'
import topicManagerRange from './ms_MY/topicManagerRange'
import trainingClass from './ms_MY/trainingClass'
import trainingCourseDetail from './ms_MY/trainingCourseDetail'
import webLive from './ms_MY/webLive'

export default {
  ...common,
  ...areaCode,
  ...communicateCenter,
  ...components,
  ...course,
  ...courseDetail,
  ...examDetail,
  ...home,
  ...humanTraining,
  ...inforList,
  ...Information,
  ...intelligentOfficialDoc,
  ...knowledgeLib,
  ...LearnRecords,
  ...Login,
  ...myCourse,
  ...myExam,
  ...mynews,
  ...mySetting,
  ...mytopic,
  ...myTrainingClass,
  ...myTrainingDetail,
  ...myWork,
  ...post,
  ...postDetail,
  ...practiceTrain,
  ...publicExam,
  ...questionnaire,
  ...rules,
  ...search,
  ...studyMap,
  ...topic,
  ...topicDetail,
  ...topicManagerRange,
  ...trainingClass,
  ...trainingCourseDetail,
  ...webLive
}
